module.exports = __webpack_public_path__ + "static/img/アセット 29@2x.c9b75f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_entry/アセット 29@2x.png
// module id = 5g3w
// module chunks = 1